import { Action, action } from 'easy-peasy'

interface State {
  myValue: boolean
}
interface Actions {
  setMyValue: Action<this, boolean>
}
// eslint-disable-next-line
interface Thunks {}

export interface ILocalStorageModel extends State, Actions, Thunks {}

export const LocalStorageModel: ILocalStorageModel = {
  myValue: true,
  setMyValue: action((state, payload) => {
    state.myValue = payload
  })
}
